var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 589,
    height: 433,
    viewBox: "0 0 589 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M424.79 84.9999C424.79 84.9999 450.3 62.9899 481.52 59.1699C481.52 59.1699 491.08 63.8399 502.12 98.2399C513.16 132.64 492.78 200.59 492.78 200.59L424.8 84.9999H424.79Z",
    fill: "url(#paint0_linear_915_1884)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M481.52 59.1699C481.52 59.1699 456.26 86.24 456.26 129.88L466.03 136.04L494.49 77.1399C494.49 77.1399 485.05 58.6499 481.53 59.1699H481.52Z",
    fill: "url(#paint1_linear_915_1884)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M465.1 133.059C465.1 133.059 458.38 95.7894 482.91 68.3994C482.91 68.3994 510.62 81.4594 522.09 129.869C533.56 178.279 503.71 207.349 503.71 207.349L465.11 133.059H465.1Z",
    fill: "#3CCBDA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.78 90.5097C210.78 90.5097 185.27 68.4997 154.05 64.6797C154.05 64.6797 144.49 69.3497 133.45 103.75C122.41 138.15 142.79 206.1 142.79 206.1L210.77 90.5097H210.78Z",
    fill: "url(#paint2_linear_915_1884)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.05 64.6797C154.05 64.6797 179.32 91.7497 179.32 135.39L169.55 141.55L141.09 82.6497C141.09 82.6497 150.53 64.1597 154.05 64.6797Z",
    fill: "url(#paint3_linear_915_1884)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.48 138.58C170.48 138.58 177.2 101.31 152.67 73.9199C152.67 73.9199 124.96 86.9799 113.49 135.39C102.02 183.8 135.07 216 135.07 216L170.47 138.57L170.48 138.58Z",
    fill: "#3CCBDA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.11 326.22C178.18 416.36 470.64 388.25 505.58 314.21C543.8 233.22 455.92 33.0698 315.78 42.4098C197.38 50.2998 88.8799 210.35 139.11 326.22Z",
    fill: "url(#paint4_linear_915_1884)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.25 313.5C192.62 387.43 447.9 375.22 485.2 307.25C516.87 249.53 442.08 73.79 313.82 80.06C185.57 86.33 119.38 242.55 155.25 313.5Z",
    fill: "#0147BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M432.42 226.37C427.39 239.85 360.07 238.26 360.14 233.42C360.54 206.52 374.93 171.24 401.8 171.48C429.55 171.73 441.79 201.29 432.42 226.37Z",
    fill: "#3CCBDA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M205.53 228.16C211.31 241.33 278.44 235.98 278.09 231.16C276.19 204.33 259.85 169.9 233.03 171.65C205.33 173.45 194.77 203.65 205.53 228.17V228.16Z",
    fill: "#3CCBDA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M279.26 277.93C269.13 280.37 290.3 314.2 324.28 314.2C354.43 314.2 371.42 279.45 367.6 277.93C363.78 276.41 345.69 285.75 320.54 285.75C295.39 285.75 283.51 276.91 279.26 277.93Z",
    fill: "#2F95CD"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M200.26 154.1C197.33 171.71 230.69 169.7 284.05 167.94C348.18 165.82 412.61 221.03 450.11 181.4C456.29 174.87 394.89 89.1401 320.79 91.0601C246.68 92.9801 202.81 138.81 200.26 154.1Z",
    fill: "url(#paint5_linear_915_1884)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M167.85 356.62C167.85 356.62 171.8 352.35 192.98 339.9C207.19 331.55 222.09 321.67 224.21 318.06C227.36 309.53 163.41 314.56 163.41 314.56L139.1 326.22C139.1 326.22 148.76 345.31 167.84 356.62H167.85Z",
    fill: "url(#paint6_linear_915_1884)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.99 168.08C118.99 168.08 135.49 178.7 124.67 203.29C124.67 203.29 47.6 245.26 52.06 291C55.78 329.17 162.27 310.69 162.27 310.69L166.09 323.43C166.09 323.43 75.63 341.13 44.42 319.86C44.42 319.86 33.8 294.65 60.13 249.21C86.46 203.77 118.99 168.08 118.99 168.08Z",
    fill: "url(#paint7_linear_915_1884)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148.79 307.16C139.09 318.14 159.68 330.15 176.61 331.99C195.61 334.06 229.35 326.54 227.31 307.41C225.27 288.28 171.54 281.43 148.79 307.16Z",
    fill: "#9979DB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150.07 309.179C149.49 312.309 217.3 313.059 218.9 301.079C220.49 289.099 154.53 284.979 150.07 309.179Z",
    fill: "#8666DD"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.72,
    d: "M505.4 90.2596C505.4 90.2596 496.41 79.1296 484.17 82.0896C471.92 85.0496 471.11 123.63 478.44 124.59C485.77 125.55 488.87 103.25 494.49 99.7496C500.1 96.2496 509.92 97.6096 509.92 97.6096L505.41 90.2696L505.4 90.2596Z",
    fill: "url(#paint8_linear_915_1884)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.72,
    d: "M123.77 106.719C123.77 106.719 128.5 101.359 139.11 103.099C149.73 104.839 155.85 126.619 161.28 124.439C166.71 122.249 162.73 86.9493 148.37 76.5693C148.37 76.5693 129.86 92.3693 123.77 106.719Z",
    fill: "url(#paint9_linear_915_1884)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.189 192.84C104.189 192.84 67.3395 235.64 69.6695 238.61C72.0095 241.58 106.509 197.16 104.189 192.84Z",
    fill: "url(#paint10_linear_915_1884)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_915_1884",
    x1: 465.1,
    y1: 200.59,
    x2: 465.1,
    y2: 59.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9ACF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1D1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_915_1884",
    x1: 475.37,
    y1: 136.04,
    x2: 475.37,
    y2: 59.1599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E8CEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_915_1884",
    x1: 170.47,
    y1: 206.1,
    x2: 170.47,
    y2: 64.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9ACF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1D1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_915_1884",
    x1: 160.2,
    y1: 141.55,
    x2: 160.2,
    y2: 64.6697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E8CEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_915_1884",
    x1: 305.12,
    y1: 387.33,
    x2: 348.25,
    y2: 43.8798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DCF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_915_1884",
    x1: 200.09,
    y1: 143.39,
    x2: 450.54,
    y2: 143.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_915_1884",
    x1: 181.72,
    y1: 356.62,
    x2: 181.72,
    y2: 313.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_915_1884",
    x1: 101.62,
    y1: 332.57,
    x2: 122.23,
    y2: 168.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E8CEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_915_1884",
    x1: 473.75,
    y1: 103.1,
    x2: 509.91,
    y2: 103.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_915_1884",
    x1: 123.77,
    y1: 100.579,
    x2: 163.61,
    y2: 100.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_915_1884",
    x1: 86.9395,
    y1: 238.75,
    x2: 86.9395,
    y2: 192.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DCF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriaIcon);
export default __webpack_public_path__ + "static/media/pria-icon.5b47651c6da17db0076af2b46775efc9.svg";
export { ForwardRef as ReactComponent };